import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import BitumenSolutions from "@/pages/BitumenSolutions";
import BitumenEquipment from "@/pages/BitumenEquipment";
import SpecialtyEquipment from "@/pages/SpecialtyEquipment";
import HeavyMachinery from "@/pages/HeavyMachinery";
import SteelFabrication from "@/pages/SteelFabrication";
import ProjectPortfolio from "@/pages/ProjectPortfolio";
import Contact from "@/pages/Contact";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/products/bitumen-solutions" element={<BitumenSolutions />} />
          <Route path="/products/bitumen-equipment" element={<BitumenEquipment />} />
          <Route path="/products/specialty-equipment" element={<SpecialtyEquipment />} />
          <Route path="/products/heavy-machinery" element={<HeavyMachinery />} />
          <Route path="/steel-fabrication" element={<SteelFabrication />} />
          <Route path="/project-portfolio" element={<ProjectPortfolio />} />
          <Route path="/contact" element={<Contact />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
